import { useState } from "react";

type SketchField = {
  label: string;
  type: string;
  optional?: boolean;
};

type SketchSection = {
  id: string;
  title: string;
  fields: SketchField[];
};

const SECTIONS: SketchSection[] = [
  {
    id: "participant",
    title: "Participant information",
    fields: [
      { label: "First name", type: "Short text" },
      { label: "Last name", type: "Short text" },
      { label: "Email", type: "Email" },
      { label: "Grade", type: "Dropdown" },
      { label: "Date of birth", type: "Date" },
      { label: "Student phone", type: "Phone", optional: true },
      { label: "Address", type: "Paragraph" },
      { label: "Gender", type: "Multiple choice" },
      { label: "Race / ethnicity", type: "Checkboxes" },
      { label: "School", type: "Multiple choice" },
    ],
  },
  {
    id: "guardian",
    title: "Parent or guardian",
    fields: [
      { label: "First name", type: "Short text" },
      { label: "Last name", type: "Short text" },
      { label: "Email", type: "Email" },
      { label: "Phone", type: "Phone" },
      { label: "Relationship", type: "Dropdown" },
      { label: "Address if different", type: "Paragraph", optional: true },
      { label: "Help with", type: "Checkboxes", optional: true },
    ],
  },
  {
    id: "additional",
    title: "Additional parent or guardian",
    fields: [
      { label: "First name", type: "Short text", optional: true },
      { label: "Last name", type: "Short text", optional: true },
      { label: "Email", type: "Email", optional: true },
      { label: "Phone", type: "Phone", optional: true },
      { label: "Relationship", type: "Dropdown", optional: true },
      { label: "Address", type: "Paragraph", optional: true },
    ],
  },
  {
    id: "emergency",
    title: "Two emergency contacts",
    fields: [
      { label: "Contact 1 first name", type: "Short text" },
      { label: "Contact 1 last name", type: "Short text" },
      { label: "Contact 1 phone", type: "Phone" },
      { label: "Contact 1 relationship", type: "Short text" },
      { label: "Contact 2 first name", type: "Short text" },
      { label: "Contact 2 last name", type: "Short text" },
      { label: "Contact 2 phone", type: "Phone" },
      { label: "Contact 2 relationship", type: "Short text" },
    ],
  },
  {
    id: "health",
    title: "Health information",
    fields: [
      { label: "Behavioral or emotional needs", type: "Yes / no" },
      { label: "Behavioral detail", type: "Paragraph" },
      { label: "Medical conditions", type: "Yes / no" },
      { label: "Medical detail", type: "Paragraph" },
      { label: "Over-the-counter medication", type: "Yes / no" },
      { label: "Emergency medical care", type: "Yes / no" },
      { label: "Physician", type: "Short text" },
      { label: "Physician phone", type: "Phone" },
      { label: "Preferred hospital", type: "Short text", optional: true },
      { label: "Insurance", type: "Short text", optional: true },
      { label: "Policy number", type: "Short text", optional: true },
    ],
  },
  {
    id: "policies",
    title: "Policies and agreements",
    fields: [
      { label: "Code of conduct", type: "Agree or meeting" },
      { label: "Behavior response", type: "Agree or meeting" },
      { label: "Dismissal policy", type: "Agree or meeting" },
      { label: "Media release", type: "Yes / no" },
    ],
  },
  {
    id: "liability",
    title: "Participation and liability",
    fields: [
      { label: "Permission to participate", type: "Agreement" },
      { label: "Transportation", type: "Agreement" },
      { label: "Assumption of risk", type: "Agreement" },
      { label: "Liability release", type: "Agreement" },
    ],
  },
];

export function OfficialFormSketch() {
  const [openId, setOpenId] = useState("");

  return (
    <div className="design-official">
      {SECTIONS.map((section) => {
        const open = openId === section.id;
        const panelId = `official-${section.id}`;
        return (
          <div className="wire design-official-section" key={section.id}>
            <button
              type="button"
              className="design-official-toggle"
              aria-expanded={open}
              aria-controls={panelId}
              onClick={() => setOpenId(open ? "" : section.id)}
            >
              <span className="design-official-chevron" aria-hidden="true">
                {open ? "▾" : "▸"}
              </span>
              <span className="design-official-title">{section.title}</span>
              <span className="design-type">
                {section.fields.length} fields · fixed
              </span>
            </button>
            {open ? (
              <ul className="design-official-fields" id={panelId}>
                {section.fields.map((field) => (
                  <li key={field.label}>
                    <span>{field.label}</span>
                    <span className="design-type">
                      {field.type}
                      {field.optional ? " · optional" : ""}
                    </span>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
